import { Button, Callout, Card, icons } from "@bruntworkwear-apps/ui";
import { downloadBase64 } from "@/shared/lib";
import styles from "./ExportCard.module.css";
import type { ExportCardProps } from "./ExportCard.types";

/**
 * Downloads the formatted workbook.
 *
 * The file arrives inline with the result rather than as a link, because
 * nothing is stored server-side. So this is a pure client-side save with no
 * second request and nothing to expire.
 */
export function ExportCard({ filename, workbookBase64 }: ExportCardProps) {
  if (!workbookBase64 || !filename) {
    return (
      <Card title="Export">
        <Callout tone="warning">
          This run did not produce a workbook. Re-run the reconciliation.
        </Callout>
      </Card>
    );
  }

  return (
    <Card title="Export">
      <div className={styles.body}>
        <p className={styles.copy}>
          Six sheets: the costed detail, calculated totals by item receipt, the comparison
          against booked, a per-order tie-out, every flag, and the parameters this run used.
          Highlighting matches the close file — blue for USA lines, purple for landing
          variances, gray where customs sits under the threshold.
          <br />
          <span className={styles.filename}>{filename}</span>
        </p>
        <Button
          leadingIcon={<icons.Download size={16} />}
          onClick={() => downloadBase64(workbookBase64, filename)}
        >
          Download workbook
        </Button>
      </div>
    </Card>
  );
}
